<script>
import Colcade from 'colcade';

export default {
  mounted() {
    new Colcade('.grid', {
      columns: '.grid-col',
      items: '.grid-item'
    });
  },
}
</script>